import { ChevronDown } from '@griply/assets';
import React, { Ref } from 'react';
import { Icon } from 'shared/components/ui/icon';
import { useTheme } from 'styled-components';

import * as Styled from './form-select-trigger.style';
import { Size } from './types';

export type FormSelectTriggerProps = {
  id?: string;
  isPlaceholder?: boolean;
  noBorders?: boolean;
  size?: Size;
  inheritColor?: boolean;
  noOverflow?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  triggerRef?: Ref<HTMLButtonElement>;
  // Rendered in the floating end slot; defaults to the open-menu chevron.
  endAdornment?: React.ReactNode;
  ariaHasPopup?: React.AriaAttributes['aria-haspopup'];
  ariaExpanded?: boolean;
  ariaControls?: string;
  children: React.ReactNode;
};

export const FormSelectTrigger: React.FC<FormSelectTriggerProps> = ({
  id,
  isPlaceholder,
  noBorders,
  size = Size.Medium,
  inheritColor,
  noOverflow,
  disabled,
  onClick,
  triggerRef,
  endAdornment,
  ariaHasPopup,
  ariaExpanded,
  ariaControls,
  children,
}) => {
  const theme = useTheme();

  const onIconClick = disabled ? undefined : onClick;

  return (
    <Styled.Container $disabled={!!disabled}>
      <Styled.Button
        ref={triggerRef}
        id={id}
        type="button"
        disabled={disabled}
        onClick={onClick}
        aria-haspopup={ariaHasPopup}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
        $isPlaceholder={!!isPlaceholder}
        $noBorders={!!noBorders}
        $size={size}
        $inheritColor={!!inheritColor}
        $noOverflow={!!noOverflow}
      >
        {children}
      </Styled.Button>
      <Styled.InteractionContainer $inheritColor={!!inheritColor} $size={size}>
        {endAdornment ?? (
          <Styled.IconContainer $disabled={!!disabled} onClick={onIconClick}>
            <Icon
              icon={ChevronDown}
              size={16}
              color={theme.palette.grey[600]}
              strokeWidth={2}
            />
          </Styled.IconContainer>
        )}
      </Styled.InteractionContainer>
    </Styled.Container>
  );
};
